import { AlertTier } from "../api-client";
export const DEFAULT_EXCHANGE_TIER_CONFIGS = [
    {
        exchange: "upbit",
        listingTiers: {
            spot: AlertTier.TIER_1,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_1,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "bithumb",
        listingTiers: {
            spot: AlertTier.TIER_1,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_1,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "binance",
        listingTiers: {
            spot: AlertTier.TIER_1,
            futures: AlertTier.TIER_1,
            alpha: AlertTier.TIER_3,
            hodler_airdrop: AlertTier.TIER_2,
            megadrop: AlertTier.TIER_2,
            launchpool: AlertTier.TIER_2,
            "pre-market": AlertTier.TIER_2,
        },
        delistingTiers: {
            spot: AlertTier.TIER_1,
            futures: AlertTier.TIER_1,
            monitoring: AlertTier.TIER_2,
        },
        defaultListingTier: AlertTier.TIER_1,
        defaultDelistingTier: AlertTier.TIER_1,
    },
    {
        exchange: "coinbase",
        listingTiers: {
            spot: AlertTier.TIER_2,
            roadmap: AlertTier.TIER_3,
        },
        delistingTiers: {
            spot: AlertTier.TIER_1,
            futures: AlertTier.TIER_1,
        },
        defaultListingTier: AlertTier.TIER_2,
        defaultDelistingTier: AlertTier.TIER_1,
    },
    {
        exchange: "coinbaseinternational",
        listingTiers: {
            futures: AlertTier.TIER_2,
            "pre-market": AlertTier.TIER_2,
        },
        delistingTiers: {
            spot: AlertTier.TIER_1,
            futures: AlertTier.TIER_1,
        },
        defaultListingTier: AlertTier.TIER_2,
        defaultDelistingTier: AlertTier.TIER_1,
    },
    {
        exchange: "bitvavo",
        listingTiers: {
            spot: AlertTier.TIER_2,
            futures: AlertTier.TIER_2,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_2,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "okx",
        listingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        delistingTiers: {
            spot: AlertTier.TIER_1,
            futures: AlertTier.TIER_1,
        },
        defaultListingTier: AlertTier.TIER_3,
        defaultDelistingTier: AlertTier.TIER_1,
    },
    {
        exchange: "bybit",
        listingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
            "soon-spot": AlertTier.TIER_3,
            "soon-futures": AlertTier.TIER_3,
            launchpad: AlertTier.TIER_3,
            "pre-market": AlertTier.TIER_3,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_3,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "robinhood",
        listingTiers: {
            spot: AlertTier.TIER_3,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_3,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "hyperliquid",
        listingTiers: {
            futures: AlertTier.TIER_3,
        },
        delistingTiers: {
            futures: AlertTier.TIER_3,
            spot: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_3,
        defaultDelistingTier: AlertTier.TIER_3,
    },
    {
        exchange: "aevo",
        listingTiers: {
            "pre-market": AlertTier.TIER_3,
        },
        delistingTiers: {
            spot: AlertTier.TIER_3,
            futures: AlertTier.TIER_3,
        },
        defaultListingTier: AlertTier.TIER_3,
        defaultDelistingTier: AlertTier.TIER_3,
    },
];
//# sourceMappingURL=tier-config.types.js.map